import React from 'react';
import { motion } from 'framer-motion';
import styles from './SectionBanner.module.css';

const iconFor = (title) => {
  const t = String(title || '').toLowerCase();
  if (t.includes('ethic') || t.includes('leadership')) return '⚖';
  if (t.includes('classroom')) return '🏫';
  if (t.includes('pedagog')) return '📚';
  if (t.includes('digital') || t.includes('edtech')) return '💻';
  if (t.includes('subject') || t.includes('academic')) return '🧠';
  if (t.includes('ocean') || t.includes('openness') || t.includes('trait')) return '🌊';
  return '🎯';
};

const SectionBanner = ({ sectionName, subtitle }) => {
  return (
    <motion.div
      className={styles.banner}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.24 }}
    >
      <span className={styles.icon}>{iconFor(sectionName)}</span>
      <div className={styles.copy}>
        <div className={styles.kicker}>Section Start</div>
        <h4 className={styles.title}>{sectionName}</h4>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
    </motion.div>
  );
};

export default SectionBanner;
